<template>
  <compare-image :left-image="fgImage" :right-image="bgImage">
    <template #left-label>
      <div class="tw-text-2xl lg:tw-text-6xl tw-font-semibold tw-left-8 tw-absolute tw-bottom-8">
        TRADITIONAL
      </div>
    </template>
    <template #right-label>
      <div class="tw-text-2xl lg:tw-text-6xl tw-font-semibold tw-right-8 tw-absolute tw-bottom-8">
        AUTHENTIC
      </div>
    </template>
  </compare-image>
</template>
<script>
import CompareImage from "./CompareImage.vue";

export default {

  props: ['bgImage', 'fgImage'],
  components: {
    CompareImage
  },
  methods: {


  },
}
</script>

<style>
@tailwind base;
@tailwind utilities;
</style>